(() => {
        const DEBUG = false;
        const log = (...a) => DEBUG && console.log('[cart-bubble]', ...a);

        const SELECTOR_CONTAINER = '#cart-count-container';

        function updateBubbleFromCount(count) {
          const container = document.querySelector(SELECTOR_CONTAINER);
          if (!container) {
            log('Missing #cart-count-container');
            return;
          }

          const itemCount = Number(count) || 0;

          if (itemCount <= 0) {
            container.innerHTML = '';
            return;
          }

          // Preserve existing translated visually-hidden text if present
          const existingHidden = container.querySelector('.visually-hidden')?.textContent?.trim();
          const fallbackHidden = `Cart contains ${itemCount} item${itemCount === 1 ? '' : 's'}`;
          const hiddenText = existingHidden || fallbackHidden;

          container.innerHTML = `
            <div class="cart-count-bubble">
              ${itemCount < 100 ? `<span aria-hidden="true">${itemCount}</span>` : ``}
              <span class="visually-hidden">${escapeHtml(hiddenText)}</span>
            </div>
          `;
        }

        function escapeHtml(str) {
          return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
        }

        let pending = null;

        async function refreshBubble() {
          try {
            const res = await fetch('/cart.js', { credentials: 'same-origin' });
            if (!res.ok) throw new Error('cart.js not ok');
            const cart = await res.json();
            log('cart.js item_count', cart?.item_count);
            updateBubbleFromCount(cart?.item_count);
          } catch (e) {
            log('refreshBubble error', e);
          }
        }

        // Debounce so multiple cart calls in a row don’t spam /cart.js
        function scheduleRefresh() {
          if (pending) cancelAnimationFrame(pending);
          pending = requestAnimationFrame(() => {
            pending = null;
            refreshBubble();
          });
        }

        // --- 1) Hook FETCH ---
        const originalFetch = window.fetch;
        window.fetch = function (...args) {
          const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

          const isCartRequest =
            url.includes('/cart/add') ||
            url.includes('/cart/change') ||
            url.includes('/cart/update') ||
            url.includes('/cart/clear') ||
            url.includes('/checkout') ||
            url.includes('cart.js') ||
            url.includes('cart.json');

          if (!isCartRequest) {
            return originalFetch.apply(this, args);
          }

          return originalFetch.apply(this, args).then((res) => {
            // Only refresh after cart-mutating endpoints (avoid infinite loop on /cart.js refresh)
            if (
              !url.includes('/cart.js') &&
              !url.includes('cart.js') &&
              !url.includes('cart.json')
            ) {
              // Give Shopify a tick to commit changes before reading /cart.js
              setTimeout(scheduleRefresh, 80);
            }
            return res;
          });
        };

        // --- 2) Hook XHR ---
        const originalOpen = XMLHttpRequest.prototype.open;
        const originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url, ...rest) {
          this.__cart_url = url || '';
          return originalOpen.call(this, method, url, ...rest);
        };

        XMLHttpRequest.prototype.send = function (...args) {
          this.addEventListener('loadend', () => {
            const url = this.__cart_url || '';
            const isCartRequest =
              url.includes('/cart/add') ||
              url.includes('/cart/change') ||
              url.includes('/cart/update') ||
              url.includes('/cart/clear');

            if (isCartRequest) {
              setTimeout(scheduleRefresh, 80);
            }
          });

          return originalSend.apply(this, args);
        };

        // --- 3) Also refresh on page load (correct bubble on first paint) ---
        document.addEventListener('DOMContentLoaded', () => {
          scheduleRefresh();
        });

        // Optional: refresh when cart drawer opens (if you use drawer)
        document.addEventListener('click', (e) => {
          const trigger = e.target.closest?.('#cart-icon-bubble');
          if (trigger) setTimeout(scheduleRefresh, 50);
        });

        log('installed');
      })();
